import { WelcomeType, userLogin, UserRegistration } from '.';

export enum UserTypes {
	Welcome = 'UserTypes/Welcome',
	Errors = 'UserTypes/Errors',
	LoginError = 'UserTypes/Error',
	Login = 'UserTypes/Login',
	Registration = 'UserTypes/Register',
	LOADING_PROFILE = 'Profile/loading',
	PROFILE_FAIL = 'Profile/Fail',
	PROFILE_SUCCESS = 'Profile/Success',
	LOGOUT_USER = 'LOGOUT_USER',
	ADMIN_LOGIN = 'ADMIN_LOGIN',
}

export type TokenType = {
	token: string;
};
export type User = {
	firstName: string;
	email: string;
};
export type UserLoginType = {
	token: TokenType;
	user: User;
};
export type UserAdminLoginType = {
	token: string;
	user: User;
};
export type UserProfileType = {
	data: {
		firstName: string;
		token: string;
	};
};
interface Welcome {
	type: typeof UserTypes.Welcome;
	payload: {
		data: WelcomeType;
	};
}

interface Errors {
	type: typeof UserTypes.Errors;
	payload: {
		errors: any;
	};
}
interface LoginError {
	type: typeof UserTypes.LoginError;
	payload: {
		errors: any;
	};
}

interface Login {
	type: typeof UserTypes.Login;

	payload: {
		isAuthenticated: true;
		data: userLogin;
	};
}

interface AdminLoginI {
	type: typeof UserTypes.ADMIN_LOGIN;

	payload: {
		isAuthenticated: true;
		data: UserAdminLoginType;
	};
}
interface Register {
	type: typeof UserTypes.Registration;
	payload: {
		data: UserRegistration;
	};
}
interface LoadProfile {
	type: typeof UserTypes.LOADING_PROFILE;
}
interface LoadProfileFail {
	type: typeof UserTypes.PROFILE_FAIL;
}
interface LoadProfileSuccess {
	type: typeof UserTypes.PROFILE_SUCCESS;
	// payload:  UserProfileType
}
interface logoutSuccess {
	type: typeof UserTypes.LOGOUT_USER;
}
export type UserTypeAction =
	| Welcome
	| Login
	| Register
	| Errors
	| LoginError
	| LoadProfile
	| LoadProfileFail
	| LoadProfileSuccess
	| logoutSuccess
	| AdminLoginI;
